import React, { useEffect, useState } from 'react'
import { adminRequest } from '../api/client'
import { Card, EmptyState, PageTitle, StatusBadge, formatDate } from '../components/Ui'
import { BackLink, DetailGrid, SummaryGrid, Timeline } from '../components/AdminCommon'

export default function MockupJobDetail({ id, navigate }) {
  const [item, setItem] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    let disposed = false
    adminRequest(`/api/v1/admin/ai/mockup-jobs/${encodeURIComponent(id)}`)
      .then((response) => { if (!disposed) setItem(response?.data || null) })
      .catch((nextError) => { if (!disposed) setError(nextError?.message || 'AI 시안 작업을 찾을 수 없습니다.') })
      .finally(() => { if (!disposed) setLoading(false) })
    return () => { disposed = true }
  }, [id])

  if (loading) return <><BackLink onClick={() => navigate('/ai/mockups')} /><Card><p>실제 AI 시안 작업을 조회하는 중입니다.</p></Card></>
  if (error || !item) return <><BackLink onClick={() => navigate('/ai/mockups')} /><Card><EmptyState title="AI 시안 작업 조회 실패" description={error || '작업을 찾을 수 없습니다.'} /></Card></>

  const outputs = item.outputs || []
  return <>
    <BackLink onClick={() => navigate('/ai/mockups')} />
    <PageTitle eyebrow="AI MOCKUP JOB · LIVE DB" title={item.id} description="ai_mockup_jobs와 Object Storage 결과 연결을 실제 DB에서 확인합니다." />
    <SummaryGrid items={[
      { label: '상태', value: <StatusBadge status={item.status} /> },
      { label: '생성 결과', value: `${outputs.length}개` },
      { label: '비용', value: `$${Number(item.cost || 0).toFixed(4)}` },
      { label: '지연', value: `${Number(item.latencyMs || 0).toLocaleString()}ms` },
    ]} />
    <div className="dashboard-grid half">
      <Card title="작업 정보"><DetailGrid items={[
        { label: '견적 요청', value: item.requestNo },
        { label: '서비스', value: item.serviceName || '-' },
        { label: '디렉터', value: item.directorName || '-' },
        { label: '디렉터 ID', value: item.directorId, wide: true },
        { label: 'AI Run ID', value: item.aiRunId || '-', wide: true },
        { label: '모델 Snapshot', value: item.modelVersion || '-', wide: true },
        { label: 'Prompt Version', value: item.promptVersion || '-', wide: true },
        { label: '생성 시각', value: formatDate(item.createdAt, true) },
        { label: '완료 시각', value: formatDate(item.completedAt, true) },
      ]} /></Card>
      <Card title="저장 결과">
        {outputs.length ? <div className="admin-file-list">{outputs.map((output, index) => <a key={output.mediaId} href={output.url} target="_blank" rel="noreferrer"><span>▧</span><strong>시안 결과 {index + 1}</strong><small>{output.mediaId}</small></a>)}</div> : <EmptyState title="저장된 시안 결과가 없습니다." description="ai_mockup_outputs에 연결된 미디어가 없습니다." />}
      </Card>
    </div>
    <Card title="작업 이력"><Timeline items={[
      { label: '시안 생성 작업 생성', detail: `${item.modelVersion || '-'} · ${item.requestNo}`, at: formatDate(item.createdAt, true) },
      { label: item.status === 'FAILED' ? '생성 실패' : '현재 작업 상태', detail: item.status === 'FAILED' ? '실패 상태로 저장됨' : `${outputs.length}개 Object Storage 결과 연결`, at: formatDate(item.completedAt || item.createdAt, true) },
    ]} /></Card>
    <Card title="데이터 원본"><p className="help-copy">존재하지 않는 작업 ID를 첫 번째 예시 작업으로 대체하지 않습니다. 실제 DB에 없으면 404로 처리됩니다.</p></Card>
  </>
}
